const payment_gateways = {
  gateway_name: 'Payment Gateways',
};

export default payment_gateways;
